import { useState } from "react";
import { HiOutlineClock } from "react-icons/hi";
import SubscribeModal from "../../../components/SubscribeModal";
import { MARKET_DATA_DELAY_MINUTES } from "../constants";

export const MarketDataDelayBadge = ({
  theme,
  delayMinutes = MARKET_DATA_DELAY_MINUTES,
}) => {
  const isDark = theme === "dark";
  const minutes = delayMinutes || MARKET_DATA_DELAY_MINUTES;

  return (
    <span
      className={`inline-flex w-fit shrink-0 items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide ${
        isDark
          ? "bg-amber-500/15 text-amber-400"
          : "bg-amber-100 text-amber-700"
      }`}
    >
      <HiOutlineClock size={11} aria-hidden />
      Delayed {minutes} min
    </span>
  );
};

/**
 * Free-user delay CTA: mobile = line 2 (badge) + line 3 (text + button).
 * Place below the tab title (line 1). Desktop: one inline row beside title.
 */
export const MarketDataDelaySubscribeInline = ({
  theme,
  delayMinutes = MARKET_DATA_DELAY_MINUTES,
  stacked = false,
}) => {
  const [showSubscribe, setShowSubscribe] = useState(false);

  const outerClass = stacked
    ? "flex w-full min-w-0 flex-col gap-1"
    : "flex w-full min-w-0 flex-col gap-1 max-sm:mt-0.5 sm:w-auto sm:flex-row sm:flex-wrap sm:items-center sm:gap-x-1.5 sm:gap-y-0";

  const actionRowClass = stacked
    ? "flex min-w-0 items-center gap-2"
    : "flex min-w-0 items-center gap-2 sm:contents";

  const textClass = stacked
    ? "min-w-0 flex-1 text-[11px] leading-snug text-slate-500"
    : "min-w-0 flex-1 text-[11px] leading-snug text-slate-500 sm:flex-initial sm:truncate sm:max-w-[11rem] lg:max-w-none";

  return (
    <>
      <div className={outerClass}>
        <MarketDataDelayBadge theme={theme} delayMinutes={delayMinutes} />
        <div className={actionRowClass}>
          <span className={textClass}>
            Subscribe for live data
          </span>
          <button
            type="button"
            onClick={() => setShowSubscribe(true)}
            className="inline-flex shrink-0 items-center rounded-full bg-blue-600 px-3 py-1 text-[11px] font-semibold text-white hover:bg-blue-500 sm:px-3 sm:py-1 sm:text-xs"
          >
            Subscribe
          </button>
        </div>
      </div>
      <SubscribeModal
        open={showSubscribe}
        onClose={() => setShowSubscribe(false)}
        title="Subscribe for realtime market data"
        description="Get live trade flash, options time & sales, and charts without the delay."
      />
    </>
  );
};
